const formatNumber = (value) => (Number(value) || 0).toLocaleString();

function DashboardCards({ summary = {} }) {

  const styles = {

    cardsWrapper: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "15px",
      marginTop: "20px",
      marginBottom: "20px"
    },

    cardBase: {
      padding: "20px",
      borderRadius: "16px",
      color: "#fff",
      boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
      transition: "transform 0.3s ease",
      cursor: "pointer"
    },

    title: {
      margin: 0,
      fontSize: "14px",
      opacity: 0.9
    },

    value: {
      marginTop: "10px",
      fontSize: "26px",
      fontWeight: "700"
    }
  };

  // Color styles (separate)
  const colors = {
    blue: { background: "linear-gradient(135deg,#2563eb,#1d4ed8)" },
    purple: { background: "linear-gradient(135deg,#7c3aed,#9333ea)" },
    green: { background: "linear-gradient(135deg,#16a34a,#22c55e)" },
    cyan: { background: "linear-gradient(135deg,#0891b2,#06b6d4)" },
    orange: { background: "linear-gradient(135deg,#ea580c,#f97316)" },
    red: { background: "linear-gradient(135deg,#dc2626,#ef4444)" }
  };

  const Card = ({ title, value, color }) => (
    <div
      style={{
        ...styles.cardBase,
        ...colors[color]
      }}
      onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-6px)"}
      onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0px)"}
    >
      <h4 style={styles.title}>{title}</h4>
      <h2 style={styles.value}>{formatNumber(value)}</h2>
    </div>
  );

  return (
    <div style={styles.cardsWrapper}>

      <Card title="Total ULBs" value={summary.totalUlbs} color="blue" />

      <Card title="Total Properties" value={summary.totalProperties} color="purple" />

      <Card title="ENP IDs" value={summary.totalEnp} color="green" />

      <Card title="Water Connections" value={summary.totalWater} color="cyan" />

      <Card title="Mobile Numbers" value={summary.totalMobile} color="orange" />

      <Card title="Municipal Connections" value={summary.totalMunicipal} color="red" />

    </div>
  );
}

export default DashboardCards;